import * as React from 'react'

import { styled } from '../../../common/ui'
import { theme } from '../theme'

interface Props {
  description: string
  hasError: boolean
}

export class FieldDescription extends React.Component<Props, {}> {
  public render() {
    const { description, hasError } = this.props
    return (
      <Container data-has-error={hasError ? '1' : '0'}>{description}</Container>
    )
  }
}

const Container = styled.div`
  padding: 0;
  margin: 0 0 5px 0;

  &[data-has-error='1'] {
    color: ${theme.colors.red};
  }
  &[data-has-error='0'] {
    color: ${theme.colors.gray};
  }
`
